import {Box, IconButton, LinearProgress, Stack, Typography} from '@mui/material';
import React from 'react';

import {IconIllustration} from 'presentation/components';
import Icon from 'presentation/icons';
import {useMediaQueries} from 'presentation/pages';
import {translations} from 'presentation/translations-new';
import {truncateText} from 'presentation/utils';
import {StyledCard, SuccessIcon} from './styles';
import {FileUploadProps} from './types';

const {
	loading: loadingText,
	finished,
	cantLoadFile,
} = translations['pt-br'].others.uploadFiles.fileUpload;

export const FileUpload = ({
	title,
	size,
	loading,
	error,
	success,
	onRemove,
	progress,
	removeDataTagId,
}: FileUploadProps) => {
	const {isMobile} = useMediaQueries();
	const truncateFileName = truncateText({
		text: title,
		containerWidth: 260,
		targetWidth: 300,
		txtWidth: 260,
		shrinkFactor: 2,
	});

	return (
		<StyledCard>
			<Stack direction="row" spacing={2} flex={1}>
				<Box>
					{success ? (
						<SuccessIcon size="medium" name="check-circle-filled" />
					) : (
						<IconIllustration
							size="custom"
							variant={error ? 'error' : 'primary'}
							customIconName="upload-file-filled"
						/>
					)}
				</Box>
				<Stack spacing={2} width="100%">
					<Box>
						<Typography variant="subtitle1" color={error ? 'error' : 'text.primary'}>
							{isMobile ? truncateFileName : title}
						</Typography>
						{!error ? (
							<Typography color="text.secondary" variant="body2">
								{size} • {success ? finished : loadingText}
							</Typography>
						) : (
							<Typography variant="subtitle1" color="error">
								{cantLoadFile}
							</Typography>
						)}
					</Box>
					{loading && !error ? (
						<LinearProgress variant="determinate" value={progress! - 1} />
					) : null}
				</Stack>
			</Stack>
			{success ? (
				<IconButton onClick={onRemove} data-tag-id={removeDataTagId}>
					<Icon name="close-default" />
				</IconButton>
			) : null}
		</StyledCard>
	);
};
